import {createTheme} from "@mantine/core";

/**
 * Application theme
 * @author Kacper Faber
 * @since 0.1.0
 */
const theme = createTheme({
    black: '#000',
    white: '#fff',

    colors: {
        textNavbar: [
            "#fef2f5",
            "#eae6e7",
            "#cdcdcd",
            "#b2b2b2",
            "#9a9a9a",
            "#8b8b8b",
            "#848484",
            "#717171",
            "#676465",
            "#5e5457"
        ],

        primary: [
            "#ebf5ff",
            "#d4e7fa",
            "#a4ccf7",
            "#72b1f6",
            "#4d99f5",
            "#3a8bf5",
            "#3083f6",
            "#2571dc",
            "#1a64c5",
            "#0056ad"
        ],

        secondary: [
            "#f5fce7",
            "#ebf6d7",
            "#d6ecaf",
            "#c0e183",
            "#aed95f",
            "#a2d347",
            "#9bd03a",
            "#86b82b",
            "#76a322",
            "#638d15"
        ],

        background: [
            "#f5f5f5",
            "#e7e7e7",
            "#cdcdcd",
            "#b2b2b2",
            "#9a9a9a",
            "#8b8b8b",
            "#848484",
            "#717171",
            "#656565",
            "#575757"
        ],

        navbar: [
            "#edf7f7",
            "#e6e7e8",
            "#cecece",
            "#b2b2b2",
            "#9a9a9a",
            "#8b8b8b",
            "#848485",
            "#707273",
            "#616568",
            "#50585e"
        ],

        fail: [
            "#ffe8e8",
            "#ffcfcf",
            "#ff9b9c",
            "#ff6464",
            "#fe3837",
            "#fe1b19",
            "#ff0909",
            "#e40000",
            "#cb0000",
            "#b10000"
        ],

        success: [
            "#e2ffec",
            "#cbffdc",
            "#99ffbb",
            "#62ff97",
            "#36ff78",
            "#18ff64",
            "#00ff59",
            "#00e349",
            "#00ca3e",
            "#00ae30"
        ],

        header: [
            "#fff",
            "#e7e7e7",
            "#cdcdcd",
            "#b2b2b2",
            "#9a9a9a",
            "#8b8b8b",
            "#848484",
            "#717171",
            "#656565",
            "#575757"
        ]
    },

    primaryColor: 'primary'
});

export default theme;